"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldSelect = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const SelectBox_1 = require("../../../SelectBox");
const Wrapper_1 = require("../Wrapper");
require("./index.scss");
const className = 'form-field-select';
const FormFieldSelect = (props) => {
    const { label, withBadge = false, error, placeholder = '', modificators, items, allowEmptyValue, value, setValue, toItem, required, disabled, name, } = props;
    const valueClassNames = (0, classFunctions_1.getClassNames)(`${className}__badge`, [
        !value ? 'hidden' : undefined,
        disabled ? 'disabled' : undefined,
    ]);
    const selectBoxModifiers = value && withBadge
        ? `${className}-airport`
        : undefined;
    const mappedItems = items === null || items === void 0 ? void 0 : items.map(toItem);
    const toValue = () => {
        var _a;
        if (value === '')
            return '';
        if (!value)
            return undefined;
        return (_a = mappedItems === null || mappedItems === void 0 ? void 0 : mappedItems.find(x => x.value === toItem(value).value)) === null || _a === void 0 ? void 0 : _a.value;
    };
    return (react_1.default.createElement(Wrapper_1.FormFieldWrapper, { label: label, error: error, modificators: modificators, required: required, additionClassNames: (0, classFunctions_1.getClassNames)(className, modificators), slot: react_1.default.createElement(react_1.default.Fragment, null,
            withBadge && value && (react_1.default.createElement("p", { className: valueClassNames }, value)),
            react_1.default.createElement("div", { className: `${className}__input` },
                react_1.default.createElement(SelectBox_1.SelectBox, { name: name, value: toValue(), onChange: (event) => {
                        const v = items === null || items === void 0 ? void 0 : items.find(x => toItem(x).value === event.target.value);
                        setValue === null || setValue === void 0 ? void 0 : setValue(v);
                    }, items: mappedItems, allowEmptyValue: allowEmptyValue, disabled: disabled, placeholder: placeholder, modificators: selectBoxModifiers }))) }));
};
exports.FormFieldSelect = FormFieldSelect;
//# sourceMappingURL=index.js.map